module.exports = __webpack_public_path__ + "static/media/karna_leonardo.f6e03c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_leonardo.png
// module id = 400
// module chunks = 0